export const REPORTS_TABLES_TYPES_LABELS = {
    'classification-report': 'Rapport de classification',
    'nodes-report': 'Rapport montant des lots',
    'nodes-by-location-report': 'Rapport montant des lots par localisation',
    'nodes-by-category-and-location-report': 'Rapport montant des lots par catégorie et localisation',
};
